/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendChartDto } from '../../models/backend-chart-dto';

export interface MonitoringComparisonsChartDataRetrieve$Params {
  /**
   * Период финансовых данных ("month" или "year"). По умолчанию "month".
   */
  period?: 'month' | 'year';
  scenario_id: number;
}

export function monitoringComparisonsChartDataRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringComparisonsChartDataRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendChartDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringComparisonsChartDataRetrieve.PATH, 'get');
  if (params) {
    rb.query('period', params.period, {});
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendChartDto>;
    }),
  );
}

monitoringComparisonsChartDataRetrieve.PATH = '/api/monitoring/comparisons/chart-data/{scenario_id}/';
